var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "channels-cont" },
    [
      _vm.getChannelTypes.length > 0
        ? _vm._l(_vm.getChannelTypes, function (channelItem, channelIndex) {
            return _c(
              "div",
              {
                key: `channel-key-${channelIndex}`,
                staticClass: "channel-item",
              },
              [
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "div",
                                _vm._g(_vm._b({}, "div", attrs, false), on),
                                [
                                  _c("channel-icon", {
                                    attrs: {
                                      "channel-data": channelItem,
                                      "is-selected": _vm.isChannelEnabled(
                                        channelItem.id
                                      ),
                                      "is-disabled": _vm.loading,
                                    },
                                    on: {
                                      assign: () =>
                                        _vm.enableChannel(channelItem),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  },
                  [_c("span", [_vm._v(_vm._s(channelItem.label))])]
                ),
              ],
              1
            )
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }